import * as React from 'react';

import { Breadcrumbs } from '@coursera/cds-core';

import {
  type LearningPathBreadcrumbTrailArgs,
  getLearningPathBreadcrumbListItems,
  getLearningPathBreadcrumbSegments,
} from 'bundles/enterprise-learning-path-description-page/utils/learningPathBreadcrumbTrail';
import GoogleMarkup from 'bundles/seo/components/GoogleMarkup';
import { getSchemaBreadcrumbsList } from 'bundles/seo/utils/schemaMarkupUtils';

const LearningPathBreadcrumbTrail = (args: LearningPathBreadcrumbTrailArgs) => {
  const segments = getLearningPathBreadcrumbSegments(args);
  const items = getLearningPathBreadcrumbListItems(args);

  if (segments.length === 0) {
    return null;
  }

  return (
    <>
      <Breadcrumbs>
        {segments.map(({ name, href }) => (
          <Breadcrumbs.Item key={href} href={href}>
            {name}
          </Breadcrumbs.Item>
        ))}
      </Breadcrumbs>
      <GoogleMarkup graph={{ '@context': 'https://schema.org', ...getSchemaBreadcrumbsList(items) }} />
    </>
  );
};

export default LearningPathBreadcrumbTrail;
